import type { LucideIcon } from 'lucide-react';
import { CircleAlert, Inbox } from 'lucide-react';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  /** Dùng cho trạng thái lỗi: đổi màu icon và chữ. */
  loi?: boolean;
}

/**
 * Trạng thái rỗng **gọn**: một dòng chữ + một hành động, không khung to.
 *
 * Bản cũ chiếm 14 đơn vị padding dọc với một vòng tròn icon 48px — tức một ô
 * trống chiếm nhiều chỗ hơn chính bảng có dữ liệu. Ở đây icon nhỏ nằm cùng
 * dòng với chữ; mô tả là dòng phụ, chỉ in khi thật cần.
 */
export function EmptyState({ icon, title, description, action, loi = false }: EmptyStateProps) {
  const Icon = icon ?? (loi ? CircleAlert : Inbox);

  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-6">
      <Icon
        size={18}
        aria-hidden="true"
        className={`shrink-0 ${loi ? 'text-bad-chu' : 'text-chu-phu'}`}
      />
      <div className="min-w-0 flex-1">
        <p className={`text-co-ban font-semibold ${loi ? 'text-bad-chu' : 'text-chu'}`}>{title}</p>
        {description && <p className="mt-0.5 text-phu text-chu-phu">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
